import { ArgError } from '../errors';
import type { InitializedUserWithAuth } from '../commons/testimServicesApi';
import type { RawBranchesData } from 'services/src/commons/mongo/models/branchesData';

let currentBranch: string | undefined;

export function getCurrentBranch() {
    return currentBranch || 'master';
}

export function setCurrentBranch(branchData: InitializedUserWithAuth['branchName'] = 'master', acknowledgeAutoDetect: boolean | string = 'false') {
    if (typeof branchData !== 'string' && branchData?.branch && branchData.branch === 'master') {
        currentBranch = 'master';
        return;
    }
    if ((branchData as RawBranchesData)?.isArchived) {
        throw new ArgError(`Branch ${(branchData as RawBranchesData).branch} is archived, run aborted.`);
    }
    if (branchData) {
        currentBranch = (branchData as RawBranchesData).branch || branchData as string;
        return;
    }
    currentBranch = acknowledgeAutoDetect ? 'master' : undefined;
}

